import React from "react";
import Helper from "../functions/Helper.js";

function RatingBox(props) {
  let {rating,reviews}=props;
  return (
    <div style={{width:65,backgroundColor:Helper.get_color(rating,"bg")}} className="table_cell rating_box">
      <div className="rating_box_text">
        {Helper.printRating(rating,1)}
      </div>
      <div className="amount_reviews">
        {reviews +" "}
        reviews
      </div>
    </div>
  );
}

export default RatingBox;
